import { render, staticRenderFns } from "./MoveAddDialog.vue?vue&type=template&id=378acd0c&scoped=true"
import script from "./MoveAddDialog.vue?vue&type=script&lang=js"
export * from "./MoveAddDialog.vue?vue&type=script&lang=js"
import style0 from "./MoveAddDialog.vue?vue&type=style&index=0&id=378acd0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378acd0c",
  null
  
)

export default component.exports